import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import GroupsWA from "../pages/GroupsWA";
import GroupCampaigns from "../pages/GroupCampaigns";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import PrivacyPolicy from "../pages/PrivacyPolicy/";
import TermsOfUse from "../pages/TermsOfUse/";
import Connections from "../pages/Connections/";
import SettingsCustom from "../pages/SettingsCustom/";
import Financeiro from "../pages/Financeiro/";
import Users from "../pages/Users";
import Roles from "../pages/Roles";
import UserGroups from "../pages/UserGroups";
import MyTeam from "../pages/MyTeam";
import Contacts from "../pages/Contacts/";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags/";
import MessagesAPI from "../pages/MessagesAPI/";
import Helps from "../pages/Helps/";
import ContactLists from "../pages/ContactLists/";
import ContactListItems from "../pages/ContactListItems/";
import { ForwardMessageProvider } from "../context/ForwarMessage/ForwardMessageContext";
// import Companies from "../pages/Companies/";
import QuickMessages from "../pages/QuickMessages/";
import BroadcastTemplates from "../pages/BroadcastTemplates/";
import WabaTemplates from "../pages/WabaTemplates/";
import Kanban from "../pages/Kanban";
import { AuthProvider } from "../context/Auth/AuthContext";
import ThemeSync from "../components/ThemeSync";
import { AuditModeProvider } from "../context/AuditMode/AuditModeContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import Route from "./Route";
//import kanbanSchedules from "../pages/kanbanSchedules/";
// Schedules deprecado: /schedules ahora apunta a AppointmentsPage (Módulo Agenda)
import Campaigns from "../pages/Campaigns";
import MetaCampaigns from "../pages/MetaCampaigns";
import ScheduledMessages from "../pages/ScheduledMessages";
// ❌ DEPRECADO: Configuración de intervalos ahora está integrada en el formulario de campañas
// import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import CampaignShippingReports from "../pages/CampaignShippingReports";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import ToDoList from "../pages/ToDoList/";
import Subscription from "../pages/Subscription/";
import Files from "../pages/Files/";
import Prompts from "../pages/Prompts";
import QueueIntegration from "../pages/QueueIntegration";
import ForgetPassword from "../pages/ForgetPassWord/"; // Reset PassWd
import ReleasesPage from "../pages/ReleasesPage"; // Historial de Versiones
import DBADashboard from "../components/DBADashboard"; // Dashboard DBA
// ✅ ELIMINADO: Performance - Ya no se necesita "Rendimiento CPU", reemplazado por "Rendimiento VPS"
import WhatsAppMetrics from "../pages/WhatsAppMetrics"; // Métricas WhatsApp
import ConnectionsDashboard from "../pages/ConnectionsDashboard"; // Dashboard Conexiones
import VPSPerformance from "../pages/Dashboard/VPSPerformance"; // Dashboard VPS Performance
import FlowBuilders from "../pages/FlowBuilders"; // FlowBuilder - Lista de Flujos
import FlowCampaigns from "../pages/FlowCampaigns"; // FlowCampaigns - Campañas de Flujo
import BusinessOnboarding from "../pages/BusinessOnboarding"; // FASE 6 — Wizard configuración inicial
import AppointmentsPage from "../pages/Appointments"; // FASE 7 — Módulo Agenda

const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        {/* 0390 — pide el tema en cuanto hay sesión. El estado del tema vive en
            App.js, por encima del proveedor de sesión, así que su primera carga
            ocurre sin token. Ver components/ThemeSync. */}
        <ThemeSync />
        <AuditModeProvider>
	  <ForwardMessageProvider>
        <TicketsContextProvider>
          <Switch>
            <Route exact path="/login" component={Login} isPrivate={false} />
            <Route exact path="/signup" component={Signup} isPrivate={false} />
			<Route exact path="/forgetpsw" component={ForgetPassword} isPrivate={false} />
            <Route exact path="/privacy" component={PrivacyPolicy} isPrivate={false} />
            <Route exact path="/terms" component={TermsOfUse} isPrivate={false} />
            {/* <Route exact path="/create-company" component={Companies} /> */}
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate />
                {/* FASE 3.1 / FASE 6: Onboarding solo si el usuario entra a Agenda y aún no hay business_config (ver layout). */}
                <Route exact path="/onboarding" component={BusinessOnboarding} isPrivate />
                <Route exact path="/appointments" component={AppointmentsPage} isPrivate />
                <Route exact path="/agenda" component={AppointmentsPage} isPrivate />
                <Route
                  exact
                  path="/tickets/:ticketId?"
                  component={TicketResponsiveContainer}
                  isPrivate
                />
                <Route
                  exact
                  path="/connections"
                  component={Connections}
                  isPrivate
                />
                <Route
                  exact
                  path="/quick-messages"
                  component={QuickMessages}
                  isPrivate
                />
                <Route
                  exact
                  path="/broadcast-templates"
                  component={BroadcastTemplates}
                  isPrivate
                />
                <Route
                  exact
                  path="/plantillas-meta"
                  component={WabaTemplates}
                  isPrivate
                />
                <Route
                  exact
                  path="/todolist"
                  component={ToDoList}
                  isPrivate
                  />
                <Route exact path="/schedules" component={AppointmentsPage} isPrivate />
                <Route exact path="/tags" component={Tags} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/helps" component={Helps} isPrivate />
                <Route exact path="/groups-wa" component={GroupsWA} isPrivate />
                <Route exact path="/group-campaigns" component={GroupCampaigns} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/roles" component={Roles} isPrivate />
                <Route exact path="/user-groups" component={UserGroups} isPrivate />
                <Route exact path="/my-team" component={MyTeam} isPrivate />
                <Route exact path="/files" component={Files} isPrivate />
                <Route exact path="/prompts" component={Prompts} isPrivate />
                <Route exact path="/queue-integration" component={QueueIntegration} isPrivate />
                <Route exact path="/releases" component={ReleasesPage} isPrivate />
                <Route exact path="/dashboard/monitoring" component={DBADashboard} isPrivate />
                {/* ✅ ELIMINADO: Ruta "/dashboard/performance" - Ya no se necesita "Rendimiento CPU" */}
                <Route exact path="/dashboard/whatsapp" component={WhatsAppMetrics} isPrivate />
                <Route exact path="/dashboard/connections" component={ConnectionsDashboard} isPrivate />
                <Route exact path="/dashboard/vps-performance" component={VPSPerformance} isPrivate />
					{/*<Route exact path="/kanban-schedules" component={kanbanSchedules} isPrivate />*/}
                <Route
                  exact
                  path="/messages-api"
                  component={MessagesAPI}
                  isPrivate
                />
                <Route
                  exact
                  path="/settings"
                  component={SettingsCustom}
                  isPrivate
                />
				        <Route 
                  exact
                  path="/kanban"
                  component={Kanban}
                  isPrivate
                />
                <Route
                  exact
                  path="/financeiro"
                  component={Financeiro}
                  isPrivate
                />
                <Route exact path="/queues" component={Queues} isPrivate />
                <Route
                  exact
                  path="/announcements"
                  component={Annoucements}
                  isPrivate
                />
                <Route
                  exact
                  path="/subscription"
                  component={Subscription}
                  isPrivate
                />
                <Route exact path="/chats/:id?" component={Chat} isPrivate />
                <Route exact path="/flowbuilders" component={FlowBuilders} isPrivate />
                <Route exact path="/flowbuilders/new" component={FlowBuilders} isPrivate />
                <Route exact path="/flowbuilders/:id/edit" component={FlowBuilders} isPrivate />
                <Route exact path="/flowcampaigns" component={FlowCampaigns} isPrivate />
                {showCampaigns && (
                  <>
                    <Route
                      exact
                      path="/contact-lists"
                      component={ContactLists}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/contact-lists/:contactListId/contacts"
                      component={ContactListItems}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaigns"
                      component={Campaigns}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/meta-campaigns"
                      component={MetaCampaigns}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/scheduled-messages"
                      component={ScheduledMessages}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaign/:campaignId/report"
                      component={CampaignReport}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaign-shipping-reports"
                      component={CampaignShippingReports}
                      isPrivate
                    />
                    {/* ❌ DEPRECADO: Configuración de intervalos ahora está integrada en el formulario de campañas */}
                    {/* <Route
                      exact
                      path="/campaigns-config"
                      component={CampaignsConfig}
                      isPrivate
                    /> */}
                  </>
                )}
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </TicketsContextProvider>
		</ForwardMessageProvider>
        </AuditModeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
